/* ============================================================
   TWELVE STUDIOS — Build Your Set + variant quick-view + scroll progress
   Reads tier config from #ts-root data-attrs (nothing hardcoded).
   Multi-variant products open a quick-view (lazy /products/{handle}.js).
   Hands off chosen variant IDs to the existing Bundles flow.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    var d = (parseInt(cents, 10) || 0) / 100;
    if (Math.round(d) === d) return '$' + d;
    return '$' + d.toFixed(2);
  }

  function init() {
    var root = document.getElementById('ts-root');
    var pill = document.getElementById('tsPill');
    var qv = document.getElementById('tsQuickView');
    if (!root || !pill) return;

    /* Move fixed overlays to <body> so they pin to the viewport, not a
       transformed/clipped ancestor. */
    if (pill.parentNode !== document.body) document.body.appendChild(pill);
    if (qv && qv.parentNode !== document.body) document.body.appendChild(qv);

    /* ---- Config ---- */
    var BUNDLE_URL = root.getAttribute('data-bundle-url') || '/pages/bundles';
    var TIERS = [
      { qty: parseInt(root.getAttribute('data-t3q'), 10) || 4, amount: parseInt(root.getAttribute('data-t3p'), 10) || 10 },
      { qty: parseInt(root.getAttribute('data-t2q'), 10) || 3, amount: parseInt(root.getAttribute('data-t2p'), 10) || 8 },
      { qty: parseInt(root.getAttribute('data-t1q'), 10) || 2, amount: parseInt(root.getAttribute('data-t1p'), 10) || 5 }
    ];
    var STORAGE_KEY = 'shazory_set_v9';

    var tiles = Array.prototype.slice.call(root.querySelectorAll('.ts-product'));
    var tileHandles = {};
    tiles.forEach(function (t) { tileHandles[t.getAttribute('data-handle')] = true; });

    /* ---- Set state: array of { handle, vid, title, price(cents), img } ---- */
    var set = [];
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (Array.isArray(saved)) {
        set = saved.filter(function (it) {
          return it && typeof it === 'object' && it.handle && it.vid && tileHandles[it.handle];
        });
      }
    } catch (e) { set = []; }

    function saveSet() { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(set)); } catch (e) {} }
    function indexOfHandle(h) { for (var i = 0; i < set.length; i++) { if (set[i].handle === h) return i; } return -1; }

    function tierFor(n) {
      for (var i = 0; i < TIERS.length; i++) {
        if (n >= TIERS[i].qty) { var isMax = (i === 0); return { amount: TIERS[i].amount, isMax: isMax, next: isMax ? null : TIERS[i - 1] }; }
      }
      return { amount: 0, isMax: false, next: TIERS[TIERS.length - 1] };
    }

    /* ---- Pill elements ---- */
    var dots = pill.querySelectorAll('.ts-dot');
    var countEl = document.getElementById('tsCount');
    var labelEl = document.getElementById('tsCountLabel');
    var tierEl = document.getElementById('tsTier');
    var subEl = document.getElementById('tsSubtotal');

    function render() {
      var n = set.length, t = tierFor(n);
      dots.forEach(function (d, idx) {
        d.classList.remove('is-on', 'is-max');
        if (idx < Math.min(n, dots.length)) d.classList.add('is-on');
        if (t.isMax) d.classList.add('is-max');
      });
      if (countEl) countEl.textContent = n;
      if (labelEl) labelEl.textContent = (n === 1 ? 'piece' : 'pieces');

      tierEl.classList.toggle('is-max', t.isMax);
      if (n === 0) {
        tierEl.innerHTML = '<strong>Add ' + t.next.qty + '</strong> for ' + '$' + t.next.amount + ' off';
      } else if (t.next) {
        var need = t.next.qty - n;
        tierEl.innerHTML = t.amount > 0
          ? '<strong>SAVE $' + t.amount + '</strong> · +' + need + ' for ' + '$' + t.next.amount
          : '<strong>Add ' + need + '</strong> for ' + '$' + t.next.amount + ' off';
      } else {
        tierEl.innerHTML = '<strong>SAVE $' + t.amount + '</strong> · max unlocked';
      }

      var subtotal = 0;
      set.forEach(function (it) { subtotal += (parseInt(it.price, 10) || 0); });
      var savedAmt = Math.min(subtotal, Math.round(t.amount * 100));
      subEl.innerHTML = money(subtotal) + (savedAmt > 0 ? '<span class="ts-save">save ' + money(savedAmt) + '</span>' : '');

      pill.classList.toggle('is-active', n > 0);
      document.body.classList.toggle('ts-set-active', n > 0);
    }

    function syncTiles() {
      tiles.forEach(function (t) { t.classList.toggle('is-selected', indexOfHandle(t.getAttribute('data-handle')) >= 0); });
    }
    function addItem(it) { set.push(it); saveSet(); syncTiles(); render(); }
    function removeHandle(h) { var i = indexOfHandle(h); if (i >= 0) { set.splice(i, 1); saveSet(); syncTiles(); render(); } }

    /* ---------- Quick view (variant picker) ---------- */
    var qvPanel = qv ? qv.querySelector('.tsqv-panel') : null;
    var qvOpenHandle = null;

    function closeQV() { if (!qv) return; qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true'); qvOpenHandle = null; }

    function openQV(handle, fallback) {
      if (!qv || !qvPanel) { if (fallback) addItem(fallback); return; }
      qvOpenHandle = handle;
      qvPanel.innerHTML = '<div class="tsqv-loading">Loading options…</div>';
      qv.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (prod) { if (qvOpenHandle === handle) buildQV(prod); })
        .catch(function () {
          if (fallback) { closeQV(); addItem(fallback); }
          else if (qvPanel) { qvPanel.innerHTML = '<div class="tsqv-loading">Couldn\u2019t load options.</div>'; }
        });
    }

    function buildQV(prod) {
      var options = prod.options || [];
      var optNames = options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
      var variants = prod.variants || [];

      var distinct = optNames.map(function (_, i) {
        var seen = {}, vals = [];
        variants.forEach(function (v) { var val = v['option' + (i + 1)]; if (val != null && !seen[val]) { seen[val] = 1; vals.push(val); } });
        return vals;
      });

      var def = null;
      for (var k = 0; k < variants.length; k++) { if (variants[k].available) { def = variants[k]; break; } }
      if (!def) def = variants[0];
      var selected = optNames.map(function (_, i) { return def ? def['option' + (i + 1)] : null; });

      function findVariant() {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < optNames.length; j++) { if (variants[i]['option' + (j + 1)] !== selected[j]) { ok = false; break; } }
          if (ok) return variants[i];
        }
        return null;
      }

      function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

      var html = '';
      html += '<button class="tsqv-close" type="button" aria-label="Close">&times;</button>';
      html += '<div class="tsqv-media"><img id="tsqvImg" src="' + ((def && def.featured_image && def.featured_image.src) || prod.featured_image || '') + '" alt=""></div>';
      html += '<div class="tsqv-body">';
      html += '<p class="tsqv-title">' + esc(prod.title || '') + '</p>';
      html += '<p class="tsqv-price" id="tsqvPrice"></p>';
      optNames.forEach(function (name, i) {
        if (distinct[i].length <= 1) return;
        html += '<div class="tsqv-opt"><span class="tsqv-opt-label">' + esc(name) + '</span><div class="tsqv-chips">';
        distinct[i].forEach(function (val) {
          html += '<button type="button" class="tsqv-chip" data-oi="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div></div>';
      });
      html += '<button class="tsqv-add" id="tsqvAdd" type="button">Add to set</button>';
      html += '</div>';
      qvPanel.innerHTML = html;

      var imgEl = qvPanel.querySelector('#tsqvImg');
      var priceEl = qvPanel.querySelector('#tsqvPrice');
      var addBtn = qvPanel.querySelector('#tsqvAdd');

      function refresh() {
        qvPanel.querySelectorAll('.tsqv-chip').forEach(function (c) {
          var oi = parseInt(c.getAttribute('data-oi'), 10);
          c.classList.toggle('is-on', c.getAttribute('data-val') === String(selected[oi]));
        });
        var v = findVariant();
        if (v) {
          priceEl.textContent = money(v.price);
          if (v.featured_image && v.featured_image.src) imgEl.src = v.featured_image.src;
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'Add to set' : 'Unavailable';
          addBtn._variant = v;
        } else {
          priceEl.textContent = '';
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          addBtn._variant = null;
        }
      }

      qvPanel.querySelectorAll('.tsqv-chip').forEach(function (c) {
        c.addEventListener('click', function () { selected[parseInt(c.getAttribute('data-oi'), 10)] = c.getAttribute('data-val'); refresh(); });
      });
      var closeBtn = qvPanel.querySelector('.tsqv-close');
      if (closeBtn) closeBtn.addEventListener('click', closeQV);
      addBtn.addEventListener('click', function () {
        var v = addBtn._variant;
        if (!v) return;
        addItem({ handle: prod.handle, vid: v.id, title: prod.title, price: v.price, img: (v.featured_image && v.featured_image.src) || prod.featured_image || '' });
        closeQV();
      });
      refresh();
    }

    if (qv) {
      qv.addEventListener('click', function (e) {
        if (e.target === qv || (e.target.classList && e.target.classList.contains('tsqv-backdrop'))) closeQV();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeQV(); });
    }

    /* ---- Wire + buttons ---- */
    tiles.forEach(function (t) {
      var btn = t.querySelector('.ts-add');
      if (!btn) return;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var handle = t.getAttribute('data-handle');
        if (indexOfHandle(handle) >= 0) { removeHandle(handle); return; }
        var fallback = {
          handle: handle,
          vid: t.getAttribute('data-id'),
          title: t.getAttribute('data-title') || '',
          price: parseInt(t.getAttribute('data-price'), 10) || 0,
          img: t.getAttribute('data-img') || ''
        };
        if (t.getAttribute('data-multi') === 'true') openQV(handle, fallback);
        else addItem(fallback);
      });
    });

    /* ---- Clear ---- */
    var clearBtn = document.getElementById('tsClear');
    if (clearBtn) clearBtn.addEventListener('click', function () { set = []; saveSet(); syncTiles(); render(); });

    /* ---- Checkout handoff ---- */
    var coBtn = document.getElementById('tsCheckout');
    if (coBtn) coBtn.addEventListener('click', function () {
      if (set.length === 0) return;
      saveSet();
      var ids = set.map(function (it) { return encodeURIComponent(it.vid); }).join(',');
      var sep = BUNDLE_URL.indexOf('?') >= 0 ? '&' : '?';
      window.location.href = BUNDLE_URL + sep + 'preselect=' + ids;
    });

    /* ---- Scroll progress: outer ---- */
    var outerRail = document.getElementById('tsOuterRail');
    var outerThumb = document.getElementById('tsOuterThumb');
    var outerNum = document.getElementById('tsOuterNum');
    var outerTotal = document.getElementById('tsOuterTotal');
    var shelfCount = root.querySelectorAll('.ts-studio').length;
    if (outerTotal) outerTotal.textContent = shelfCount;

    function updateOuter() {
      if (!outerRail || !outerThumb) return;
      var max = outerRail.scrollWidth - outerRail.clientWidth;
      if (max <= 0) { outerThumb.style.width = '100%'; outerThumb.style.left = '0'; if (outerNum) outerNum.textContent = '1'; return; }
      var visible = outerRail.clientWidth / outerRail.scrollWidth;
      var pos = outerRail.scrollLeft / max;
      outerThumb.style.width = Math.max(visible * 100, 6) + '%';
      outerThumb.style.left = (pos * (1 - visible) * 100) + '%';
      if (outerNum && shelfCount > 0) outerNum.textContent = Math.min(shelfCount, Math.round(pos * (shelfCount - 1)) + 1);
    }
    if (outerRail) {
      outerRail.addEventListener('scroll', updateOuter, { passive: true });
      window.addEventListener('resize', updateOuter);
      setTimeout(updateOuter, 60);
    }

    /* ---- Scroll progress: inner (per shelf) ---- */
    root.querySelectorAll('.ts-studio').forEach(function (studio) {
      var rail = studio.querySelector('.ts-inner-rail');
      var thumb = studio.querySelector('.ts-inner-thumb');
      if (!rail || !thumb) return;
      function updateInner() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) { thumb.style.width = '100%'; thumb.style.left = '0'; return; }
        var visible = rail.clientWidth / rail.scrollWidth;
        var pos = rail.scrollLeft / max;
        thumb.style.width = Math.max(visible * 100, 8) + '%';
        thumb.style.left = (pos * (1 - visible) * 100) + '%';
      }
      rail.addEventListener('scroll', updateInner, { passive: true });
      window.addEventListener('resize', updateInner);
      setTimeout(updateInner, 60);
    });

    /* ---- Initial paint ---- */
    syncTiles();
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
